import { useUiStore } from '@/stores/ui.store';
import { type JSX, Show } from 'solid-js';
import { Portal } from 'solid-js/web';
import { Motion, Presence } from 'solid-motionone';
import { Sidebar } from './Sidebar';

export const Drawer = (): JSX.Element => {
  const { mobileDrawerOpen, closeMobileDrawer } = useUiStore();
  return (
    <Portal>
      <Presence exitBeforeEnter>
        <Show when={mobileDrawerOpen()}>
          <div class="fixed inset-0 z-50 flex">
            <Motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              class="absolute inset-0 bg-black/50"
              onClick={closeMobileDrawer}
              role="presentation"
            />
            <Motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ duration: 0.25, easing: 'ease-out' }}
              class="relative z-10 h-full"
            >
              <Sidebar variant="drawer" onLinkClick={closeMobileDrawer} />
            </Motion.div>
          </div>
        </Show>
      </Presence>
    </Portal>
  );
};
